export default { 
    capFirstLetter(val) {
      return val.charAt(0).toUpperCase() + val.slice(1);
    },
    convertArrayOfObjectsToCSV(args) {
        let result;
        let ctr;

        const data = args.data || null;
        if (data == null || !data.length) {
          return null;
        }

        const columnDelimiter = args.columnDelimiter || ',';
        const lineDelimiter = args.lineDelimiter || '\n';

        const keys = Object.keys(data[0]);

        result = '';
        result += keys.join(columnDelimiter);
        result += lineDelimiter;

        data.forEach((item) => {
          ctr = 0;
          keys.forEach((key) => {
            if (ctr > 0) result += columnDelimiter;
            result +=
              typeof item[key] === 'string'
                ? item[key].replaceAll(',', ' ').replaceAll('\n', ' ')
                : item[key];
            ctr += 1;
          });
          result += lineDelimiter;
        });
        return result;
    },
      


  };


// WEBPACK FOOTER //
// ./src/services/Helpers.js